<nav mat-tab-nav-bar>
    <a
        mat-tab-link
        [routerLink]="['gesamt']"
        routerLinkActive
        #laborGesamt="routerLinkActive"
        [active]="laborGesamt.isActive"
        >Gesamt</a
    >
    <a
        mat-tab-link
        [routerLink]="['mitarbeiter']"
        routerLinkActive
        #laborMitarbeiter="routerLinkActive"
        [active]="laborMitarbeiter.isActive"
        >Mitarbeiter</a
    >
    <a
        mat-tab-link
        [routerLink]="['artikel']"
        routerLinkActive
        #laborArtikel="routerLinkActive"
        [active]="laborArtikel.isActive"
        >Artikel</a
    >
</nav>
<router-outlet></router-outlet>
